<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()" v-click-outside="handleHide">
    <button :class="b('toggle')" @click="handleToggle">
      <p :class="b('toggle-label')" v-if="isLabelShow">
        {{ placeholder }}
      </p>

      <span :class="b('toggle-values')" v-else>
        <span
          :class="b('toggle-value')"
          v-for="value in displayedValues"
          :key="value.id"
        >
          <span
            v-if="value.icon && value.type === 'fiat'"
            :class="[b('toggle-icon'), 'fi', `fi-${value.icon}`]"
          ></span>

          <img
            v-else-if="value.type === 'crypto' && value.label"
            :class="b('toggle-icon', { crypto: true })"
            :src="
              require(`@/assets/images/crypto/${value.label.toLowerCase()}.svg`)
            "
            alt=""
          />

          {{ value.label }}

          <button
            :class="b('toggle-remove')"
            @click.stop="handleRemoveValue(value)"
          >
            <span :class="b('toggle-icon')" v-html="displayedRemoveIcon"></span>
          </button>
        </span>
      </span>

      <span :class="b('toggle-group')">
        <span :class="b('toggle-counter')" v-if="isCounterShow">
          {{ displayedCounter }}
        </span>

        <span
          :class="b('toggle-icon', { active: isVisible })"
          v-html="displayedChevronIcon"
        ></span>
      </span>
    </button>

    <div :class="b('options', { active: isVisible })">
      <button
        :class="b('option', { active: values.includes(option.id) })"
        v-for="option in options"
        :key="option.id"
        @click="handleOption(option)"
      >
        <span
          v-if="option.icon && option.type === 'fiat'"
          :class="[b('option-icon'), 'fi', `fi-${option.icon}`]"
        ></span>

        <img
          v-else-if="option.type === 'crypto' && option.label"
          :class="b('option-icon', { crypto: true })"
          :src="
            require(`@/assets/images/crypto/${option.label.toLowerCase()}.svg`)
          "
          alt=""
        />

        {{ option.label }}
      </button>
    </div>
  </div>
</template>
